import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-locize-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import commonEn from './assets/i18n/en/common.json'
import commonFr from './assets/i18n/fr/common.json'
import talentAreaEn from './assets/i18n/en/talentArea.json'
import talentAreaFr from './assets/i18n/fr/talentArea.json'
import campaignEn from './assets/i18n/en/campaign.json'
import campaignFr from './assets/i18n/fr/campaign.json'
import crmEn from './assets/i18n/en/crm.json'
import crmFr from './assets/i18n/fr/crm.json'
import loginFr from './assets/i18n/fr/login.json'
import loginEn from './assets/i18n/en/login.json'
import settingsEn from './assets/i18n/en/settings.json'
import settingsFr from './assets/i18n/fr/settings.json'

const locizeOptions = {
  projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
  apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
  referenceLng: 'fr',
}

const isDevEnv = process.env.NODE_ENV === 'development'
const i18Lng = localStorage.getItem('i18nextLng')

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: i18Lng || (navigator?.language || 'en').substring(0, 2),
    fallbackLng: 'en',
    fallbackNS: false,
    supportedLngs: ['fr', 'en'],
    wait: true,
    debug: false,
    backend: locizeOptions,
    saveMissing: true,
  })

if (!isDevEnv) {
  i18n.addResourceBundle('fr', 'common', commonFr)
  i18n.addResourceBundle('fr', 'talentArea', talentAreaFr)
  i18n.addResourceBundle('fr', 'campaign', campaignFr)
  i18n.addResourceBundle('fr', 'crm', crmFr)
  i18n.addResourceBundle('fr', 'settings', settingsFr)
  i18n.addResourceBundle('fr', 'loginFr', loginFr)

  i18n.addResourceBundle('en', 'common', commonEn)
  i18n.addResourceBundle('en', 'talentArea', talentAreaEn)
  i18n.addResourceBundle('en', 'campaign', campaignEn)
  i18n.addResourceBundle('en', 'crm', crmEn)
  i18n.addResourceBundle('en', 'settings', settingsEn)
  i18n.addResourceBundle('en', 'loginEn', loginEn)
}
if (window.Cypress) {
  window.i18n = i18n
}
export default i18n
